import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Chip, Divider, Grid } from '@mui/material';
import MyModal from '../MyModal/MyModal';
import { jobStatusViewModalStyles } from '../JobStatusViewModal/JobStatusViewModal.styles';
import { jobTypeName } from '../../utils/jobType';

const JobDetailsModal = ({ open, onClose, job }) => {
  const { t } = useTranslation();

  if (!job) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString(
      t('common.locale', { defaultValue: 'tr-TR' }),
      { year: 'numeric', month: 'long', day: 'numeric' }
    );
  };

  const contract = job.contract || null;
  const firm = job.firm || contract?.firm || null;

  return (
    <MyModal
      open={open}
      onClose={onClose}
      title={t('jobs.viewStatus')}
      maxWidth="md"
      disableBackdropClose
      disableEscapeKeyDown
    >
      <Box>
        <Box sx={jobStatusViewModalStyles.header}>
          <Typography variant="h6" sx={jobStatusViewModalStyles.jobTitle}>
            {job.job_title || '-'}
          </Typography>
          <Divider sx={jobStatusViewModalStyles.divider} />
        </Box>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={jobStatusViewModalStyles.detailsContainer}>
              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('jobs.table.jobStatus')}:
                </Typography>
                <Chip
                onClick={() => {
                }}
                  label={job.job_status || '-'}
                  color={
                    job.job_status === 'ONAYLANDI'
                      ? 'success'
                      : job.job_status === 'DEGERLENDIRMEDE'
                      ? 'info'
                      : job.job_status === 'YAZIMDA'
                      ? 'warning'
                      : job.job_status === 'TAMAMLANDI'
                      ? 'success'
                      : 'default'
                  }
                  variant="filled"
                  sx={jobStatusViewModalStyles.statusChip}
                />
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('jobs.table.jobType')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {jobTypeName(job)
                    ? t(`jobs.jobTypes.${jobTypeName(job)}`, { defaultValue: jobTypeName(job) })
                    : '-'}
                </Typography>
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.firm')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {firm?.firm_name || firm?.firm_short_name || '-'}
                </Typography>
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.signingDate')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {formatDate(contract?.contract_signing_date)}
                </Typography>
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.workStartDate')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {formatDate(contract?.work_start_date)}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={jobStatusViewModalStyles.detailsContainer}>
              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.subject')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {contract?.contract_subject?.name || '-'}
                </Typography>
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.scopeOfWork')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {contract?.scope_of_work?.name || '-'}
                </Typography>
              </Box>

              <Box sx={jobStatusViewModalStyles.detailRow}>
                <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                  {t('contractDetails.pricingMethod')}:
                </Typography>
                <Typography variant="body2" sx={jobStatusViewModalStyles.value}>
                  {contract?.pricing_method?.name || '-'}
                </Typography>
              </Box>

              {job.description_of_job && (
                <Box sx={jobStatusViewModalStyles.detailRowWithDescription}>
                  <Typography variant="subtitle2" sx={jobStatusViewModalStyles.label}>
                    {t('jobs.form.description')}:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={jobStatusViewModalStyles.descriptionValue}
                  >
                    {job.description_of_job}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MyModal>
  );
};

export default JobDetailsModal;

